<template>
    <div class="row">
        <div class="col-12 col-md-6 mb-2">
            <label class="akkurate-dark small" for="first_name">Corporate Name <star></star></label>
            <b-form-group id="first_name" label-for="first_name">
                <b-form-input class="mt-1 field-container fields" type="text" placeholder="Enter Group Name"
                    v-model="form.first_name"></b-form-input>
                <errors v-if="form.errors.first_name">
                    {{ form.errors.first_name[0] }}
                </errors>
            </b-form-group>
        </div>

        <div class="col-12 col-md-6 mb-2">
            <label class="akkurate-dark small" for="email">Corporate Email</label>
            <b-form-group id="email" label-for="email">
                <b-form-input class="mt-1 field-container fields" type="email"
                    placeholder="Enter Group Email Address" v-model="form.email"></b-form-input>
                <errors v-if="form.errors.email">
                    {{ form.errors.email[0] }}
                </errors>
            </b-form-group>
        </div>

        <div class="col-12 col-md-6 mb-2">
            <label class="akkurate-dark small" for="phone">Phone Number<star></star></label>
            <b-form-group id="phone" label-for="phone">
                <b-form-input class="mt-1 field-container fields" type="number"
                    placeholder="Enter Phone Number Eg. 0244411100" v-model="form.mobile"></b-form-input>
                <errors v-if="form.errors.mobile">
                    {{ form.errors.mobile[0] }}
                </errors>
            </b-form-group>
        </div>


        <div class="col-12 col-md-6 mb-2">
            <label class="akkurate-dark small" for="mobile_secondary">Secondary Phone Number</label>
            <b-form-group id="mobile_secondary" label-for="mobile_secondary">
                <b-form-input class="mt-1 field-container fields" type="number"
                    placeholder="Enter Phone Number Eg. 0244411100" v-model="form.mobile_secondary"></b-form-input>
                <errors v-if="form.errors.mobile_secondary">
                    {{ form.errors.mobile_secondary[0] }}
                </errors>
            </b-form-group>
        </div>

        <div class="col-12 col-md-6 mb-2">
            <label class="akkurate-dark small" for="fund_source">Source of funds</label>
            <b-form-group id="fund_source" label-for="fund_source">
                <b-form-input class="mt-1 field-container fields" type="text" placeholder="Enter Source of funds"
                    v-model="form.fund_source"></b-form-input>
                <errors v-if="form.errors.fund_source">
                    {{ form.errors.fund_source[0] }}
                </errors>
            </b-form-group>
        </div>

        <div class="col-12 col-md-6 mb-2">
            <label class="akkurate-dark small" for="company_regulations">Company Regulations</label>
            <b-form-group id="company_regulations" label-for="company_regulations">
                <b-form-input class="mt-1 field-container fields" type="text"
                    placeholder="Enter Company Regulations" v-model="form.company_regulations"></b-form-input>
                <errors v-if="form.errors.company_regulations">
                    {{ form.errors.company_regulations[0] }}
                </errors>
            </b-form-group>
        </div>

        <div class="col-12 col-md-6 mb-2">
            <label class="akkurate-dark small"for="mandate">Mandate</label>
            <b-form-group id="mandate" label-for="mandate">
                <multiselect class="mt-1 field-container" v-model="form.mandate" selectLabel="" deselectLabel=""
                    :options="mandates"></multiselect>
                <errors v-if="form.errors.mandate">
                    {{ form.errors.mandate[0] }}
                </errors>
            </b-form-group>
        </div>
        <div class="col-md-6 mb-2">
            <div class="form-group">
                <label class="akkurate-dark small">Business Type</label>
                <!-- <input type="text" class="form-control" v-model="form.business_type"> -->
                <b-form-group id="business_type" label-for="business_type">
                    <b-form-input v-model="form.business_type" id="business_type"
                        class="mt-1 field-container fields" type="text" placeholder="Entern Business Type">
                    </b-form-input>
                </b-form-group>
                <errors v-if="form.errors.business_type">{{ form.errors.business_type[0] }}
                </errors>
            </div>
        </div>
        <div class="col-md-6 mb-2">
            <div class="form-group">
                <label class="akkurate-dark small">TIN Number</label>
                <!-- <input type="text" class="form-control" v-model="form.tin_number"> -->
                <b-form-group id="tin_number" label-for="tin_number">
                    <b-form-input v-model="form.tin_number" id="tin_number" class="mt-1 field-container fields"
                        type="text" placeholder="Entern Tin Number">
                    </b-form-input>
                </b-form-group>
                <errors v-if="form.errors.tin_number">{{ form.errors.tin_number[0] }}</errors>
            </div>
        </div>
    </div>
</template>
<script>
import Multiselect from 'vue-multiselect'
export default {
    name: "CorporateDetails",
    props: ['form', 'roles', 'add_or_edit'],
    data() {
        return {
            mandates: ["ONLY_PRINCIPAL_SIGNATORY", "PRINCIPAL_SIGNATORY_AND_ANY_OTHER_ONE",
                "ANY_OTHER_TWO_OF_THE_SIGNATORIES"],
        }
    },
    components: {
        Multiselect
    },

    methods: {

    }
}
</script>